import React from "react";

import LearningPathStepItemCard from "components/LearningPathStepItemCard";
import {
  Header,
  ItemCarousel,
  ProgressBar,
  ProgressFill,
  Section,
  StepDescription,
  StepMeta,
  StepTitle,
} from "./styled";

export default function LearningPathStepSection({
  loadingItemId,
  onCompleteItem,
  onOpenItem,
  step,
}) {
  const percent = Math.max(0, Math.min(Number(step?.completionPercent || 0), 100));

  return (
    <Section>
      <Header>
        <div>
          <StepMeta>Step {step?.order || ""} · {percent}% complete</StepMeta>
          <StepTitle>{step?.title}</StepTitle>
          {step?.description ? <StepDescription>{step.description}</StepDescription> : null}
        </div>
        <ProgressBar>
          <ProgressFill style={{ width: `${percent}%` }} />
        </ProgressBar>
      </Header>
      <ItemCarousel gap={18}>
        {(step?.items || []).map((item) => (
          <LearningPathStepItemCard
            key={`${step?.id}-${item?.itemId || item?.id}`}
            item={item}
            loading={loadingItemId === item?.itemId}
            onComplete={onCompleteItem}
            onOpen={onOpenItem}
          />
        ))}
      </ItemCarousel>
    </Section>
  );
}
